export let BUILD_NUMBER;
BUILD_NUMBER = "v2023.09.06.01.prod";
BUILD_NUMBER = "golive"
